export const isSelectedProductSelection = (productSelection) => productSelection.type === 'SELECTED_PRODUCTS';
